import { DASHBOARD_ANALYTICS_KEYS, getLanguage } from '../../../constants/defaultValues';

export const getDateFormat = () => {
  const systemLanguage = getLanguage();
  if (systemLanguage.includes(DASHBOARD_ANALYTICS_KEYS.ENGLISH)) {
    return DASHBOARD_ANALYTICS_KEYS.DATE_FORMAT_DAY_MONTH_YEAR_USA;
  }
  return DASHBOARD_ANALYTICS_KEYS.DATE_FORMAT_DAY_MONTH_YEAR_BR;
};
